module.exports = __webpack_public_path__ + "static/media/how_work_3.3344fd8f.svg";